import {UPDATE_CHECKOUT_SETTINGS} from '.';
import resolveThemeFromSettings from "./resolveThemeFromSettings";

const updateCheckoutSettings = (checkoutSettings) => {
  return (dispatch) => {
    if (checkoutSettings) {
      dispatch({
        type: UPDATE_CHECKOUT_SETTINGS,
        checkoutSettings
      });

      resolveThemeFromSettings(checkoutSettings, {dispatch});
    }
  };

};

export default updateCheckoutSettings;
